import { ApiCall } from '../helper/axios';
const BASE = '/api/meeting-scorer';
const meetingScorerService = {
    listMeetings(params = {}, token) {
        return ApiCall('GET', `${BASE}/meetings`, params, { Authorization: token || '' });
    },
    /** Re-reads the Meeting AMs' Google Calendars for today / tomorrow (ET YYYY-MM-DD); no AM emails. */
    refreshFromCalendar(date, token) {
        return ApiCall('POST', `${BASE}/meetings/calendar-sync`, { date }, { Authorization: token || '' }, 3 * 60 * 1000);
    },
    /** Emails the day's external meetings schedule (date = ET YYYY-MM-DD). */
    sendSchedule(date, token) {
        return ApiCall('POST', `${BASE}/meetings/schedule-email`, { date }, { Authorization: token || '' });
    },
    /** Score Report tab — every meeting in the range grouped by client: data { from, to, rows } */
    getScoreReport(params, token) {
        return ApiCall('GET', `${BASE}/score-report`, params, { Authorization: token || '' });
    },
    /** Email-link page: the meeting, what it needs, clients and reasons. No module access needed. */
    getMeetingAction(id, token) {
        return ApiCall('GET', `${BASE}/utility/meeting-action/${id}`, '', { Authorization: token || '' });
    },
    /** Email-link page: set the client and/or the missing-transcript reason. */
    updateMeetingAction(id, payload, token) {
        return ApiCall('PATCH', `${BASE}/utility/meeting-action/${id}`, payload, { Authorization: token || '' });
    },
    /** Score Report: one client's transcripts in a date range, as one PDF (blob). */
    downloadClientTranscripts(params, token) {
        return ApiCall('GET', `${BASE}/score-report/transcripts`, params, { Authorization: token || '' }, 5 * 60 * 1000, 'blob');
    },
    getOptions(token) {
        return ApiCall('GET', `${BASE}/options`, '', { Authorization: token || '' });
    },
    createMeetings(meetings, token) {
        return ApiCall('POST', `${BASE}/meetings`, { meetings }, { Authorization: token || '' });
    },
    getMeeting(id, token) {
        return ApiCall('GET', `${BASE}/meetings/${id}`, '', { Authorization: token || '' });
    },
    updateMeeting(id, payload, token) {
        return ApiCall('PATCH', `${BASE}/meetings/${id}`, payload, { Authorization: token || '' });
    },
    /** Scores the meeting again in the background (202); the list shows it as regenerating until done. */
    regenerateMeeting(id, token) {
        return ApiCall('POST', `${BASE}/meetings/${id}/regenerate`, {}, { Authorization: token || '' });
    },
    /** Remaps a typed-in client to the portal client once it has been added (no re-scoring). */
    linkClient(id, clientId, token) {
        return ApiCall('PATCH', `${BASE}/meetings/${id}/client`, { client_id: clientId }, { Authorization: token || '' });
    },
    deleteMeeting(id, token) {
        return ApiCall('DELETE', `${BASE}/meetings/${id}`, '', { Authorization: token || '' });
    },
    /** Score report as HTML (same content as the PDF) — data: { html, report_url } */
    getReport(id, token) {
        return ApiCall('GET', `${BASE}/meetings/${id}/report`, '', { Authorization: token || '' });
    },
    /** The PDF as a blob; the filename comes from Content-Disposition. */
    downloadReport(id, token) {
        return ApiCall('GET', `${BASE}/meetings/${id}/report/download`, '', { Authorization: token || '' }, 2 * 60 * 1000, 'blob');
    },
    /** Transcript as a PDF blob; the filename comes from Content-Disposition. */
    downloadTranscript(id, token) {
        return ApiCall('GET', `${BASE}/meetings/${id}/transcript/download`, '', { Authorization: token || '' }, 2 * 60 * 1000, 'blob');
    },
    /** Fireflies transcript, fetched on demand — data: { title, lines: [{ time, speaker, role, text }] } */
    getTranscript(id, token) {
        return ApiCall('GET', `${BASE}/meetings/${id}/transcript`, '', { Authorization: token || '' }, 2 * 60 * 1000);
    },
};
export default meetingScorerService;
